import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import { USER_ROLES } from './utils/constants';
import CreateBusinessUser from './components/admin/CreateBusinessUser';

// Pages
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import AdminLayout from './pages/AdminLayout';
import BusinessLayout from './pages/BusinessLayout';
import AdminDashboardPage from './pages/AdminDashboard';
import BusinessDashboardPage from './pages/BusinessDashboard';
import BusinessesPage from './pages/Businesses';
import CreateBusinessPage from './pages/CreateBusinessPage';
import CreateApplicationPage from './pages/CreateApplicationPage';
import NotFound from './pages/NotFound';
import EditApplicationPage from './pages/EditApplicationPage';
import EditUserPage from './pages/EditUserPage';
import AdminSubscribers from './pages/AdminSubscribers';
// Business User Pages
import BusinessApplications from './pages/BusinessApplications';
import EditBusinessPage from './pages/EditBusinessPage';
import BusinessDetailPage from './pages/BusinessDetailPage';
import BusinessUsersPage from './pages/BusinessUsersPage';
import AdminAuditLogs from './pages/AdminAuditLogs';   // ✅ import new page
import BusinessAuditLogs from './pages/BusinessAuditLogs';
import BusinessUsers from './pages/BusinessUsers';
import CreateApplicationPage2 from './pages/CreateApplicationPage2';
import ApplicationsPage from './pages/ApplicationsPage';
import EditApplicationPage2 from './pages/EditApplicationPage2';
import CreateApplicationPage3 from './pages/CreateApplicationPage3';
import EditApplicationPage3 from './pages/EditApplicationPage3';
import BusinessProfile from './pages/BusinessProfile';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* ✅ DEFAULT: Always open login */}
          <Route path="/" element={<Navigate to="/admin-login" replace />} />

          {/* Public Routes */}
          <Route path="/admin-login" element={<Login user="ADMIN"/>} />
          <Route path="/business-login" element={<Login user="BUSINESS_USER"/>} />
          <Route path="/change-password" element={<ChangePassword />} />

          {/* ================= ADMIN ROUTES ================= */}
          <Route
            path="/admin" //route path fixed
            element={
              <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN]}>
                {/* what to render */}
                <AdminLayout />   
              </ProtectedRoute>
            }
          >
            {/* child routes are relative to "/admin"  */}
            <Route index element={<Navigate to="dashboard" replace />} />
            {/* //by default if /admin is it  go to dashboard or admin/dashboard  */}
            
            <Route path="dashboard" element={<AdminDashboardPage />} />
            <Route path="businesses" element={<BusinessesPage />} />
            <Route path="businesses/create" element={<CreateBusinessPage />} />
            <Route path="businesses/:tenantId" element={<BusinessDetailPage />} />
            <Route path="businesses/:tenantId/edit" element={<EditBusinessPage />} />
            <Route path="businesses/:tenantId/create-user" element={<CreateBusinessUser />} />
            <Route path="businesses/:tenantId/users" element={<BusinessUsers />} />
            <Route path="users/:userId/edit" element={<EditUserPage />} />
            <Route path="business/:tenantId/applications/create" element={<CreateApplicationPage />} />
            {/* <Route path="applications/:appId/edit" element={<EditApplicationPage />} /> */}
            {/* <Route path="applications/create" element={<CreateApplicationPage2 />} />
            <Route path="subscribers" element={<AdminSubscribers />} />
            <Route path="logs" element={<AdminAuditLogs />} />
            <Route path="applications" element={<ApplicationsPage />} />
            <Route path="applications/:appId/edit" element={<EditApplicationPage2 />} /> */}

            
            <Route path="business/:tenantId/applications/create" element={<CreateApplicationPage />} />
            <Route path="applications/create" element={<CreateApplicationPage3 />} />
            <Route path="subscribers" element={<AdminSubscribers />} />
            <Route path="logs" element={<AdminAuditLogs />} />
            <Route path="applications" element={<ApplicationsPage />} />
            <Route path="applications/:appId/edit" element={<EditApplicationPage3 />} />
            {/* <Route path="applications/create" element={<CreateApplicationPage />} /> */}
           
          </Route>

          {/* ================= BUSINESS USER ROUTES ================= */}
          <Route
            path="/business"
            element={
              <ProtectedRoute allowedRoles={[USER_ROLES.BUSINESS_USER]}>
                <BusinessLayout />
              </ProtectedRoute>
            }
          >
            {/* FIXED: All child routes are relative to "/business" */}
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<BusinessDashboardPage />} />
            <Route path="applications" element={<BusinessApplications />} />
            <Route path="applications/create" element={<CreateApplicationPage3 />} />
            <Route path="applications/:appId/edit" element={<EditApplicationPage3 />} />
            <Route path="applications/:appId" element={<div>Application Detail Page</div>} />
            <Route path="profile" element={<BusinessProfile />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="subscribers" element={<AdminSubscribers />} />
            <Route path="audit-logs" element={<AdminAuditLogs />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;